(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ✅ ADD: Make "Submit Order" + "Wholesale Account" menu items look like green buttons (add class by text)
  document.addEventListener('DOMContentLoaded', function() {
    var links = document.querySelectorAll(
      '.header a, .header__inline-menu a, .list-menu a, nav a'
    );

    var buttonTexts = [
      'submit order',
      'wholesale account',
      'create wholesale account'
    ];

    links.forEach(function(a) {
      var text = (a.textContent || '').trim().toLowerCase();
      if (buttonTexts.indexOf(text) !== -1) {
        a.classList.add('submit-order-btn');
      }
    });
  });

  /*
    ⚠️ OPTIONAL:
    If you want cart click to ALWAYS go to /cart page (disable drawer/notification),
    UNCOMMENT this block.
    If you want Dawn cart-notification / cart-drawer to work, keep it commented.
  */
  /*
  document.addEventListener('click', function(e) {
    var cartLink = e.target.closest('#cart-icon-bubble');
    if (!cartLink) return;

    e.preventDefault();
    e.stopPropagation();

    window.location.href = cartLink.getAttribute('href') || '/cart';
  }, true);
  */

  // ✅ FIX: Update header cart bubble immediately after AJAX add-to-cart (no reload needed)
  (function () {
    function updateHeaderCartBubble(count) {
      const cartLink = document.getElementById('cart-icon-bubble');
      if (!cartLink) return;

      const bubble = cartLink.querySelector('.cart-count-bubble');
      if (!bubble) return;

      let countSpan = bubble.querySelector('span[aria-hidden="true"]');

      // If number span doesn't exist, create it (safety)
      if (!countSpan) {
        countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(countSpan, bubble.firstChild);
      }

      countSpan.textContent = String(count);

      if (count > 0) {
        bubble.classList.remove('hidden');
        bubble.style.display = '';
      } else {
        bubble.classList.add('hidden');
        bubble.style.display = 'none';
      }
    }

    async function refreshCartCount() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) return;
        const cart = await res.json();
        updateHeaderCartBubble(cart.item_count || 0);
      } catch (e) {}
    }

    // Patch fetch: detect /cart/add calls
    const originalFetch = window.fetch;
    window.fetch = async function () {
      const res = await originalFetch.apply(this, arguments);

      try {
        const url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
          setTimeout(refreshCartCount, 250);
        }
      } catch (e) {}

      return res;
    };

    // Fallback: form submit to /cart/add
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (!form) return;

        const action = (form.getAttribute('action') || '').toLowerCase();
        if (action.includes('/cart/add')) {
          setTimeout(refreshCartCount, 450);
        }
      },
      true
    );

    document.addEventListener('DOMContentLoaded', refreshCartCount);
  })();

  } catch(e) { console.error(e); }
})();
})();
